<template>
  <div class="page-body">
    <div>
      <van-empty image="search" :description="hauce_errmsg" v-show="huace_status === 0"></van-empty>

      <div v-show="huace_status !== 0">
        <loading v-if="is_loading" />

        <div class="cart_content" v-else>
          <div class="cart_content_div">
            <div class="cart_content_top">
              <div class="cart_content_top_center">
                <marquee direction="left" scrollamount="5">
                  点击右上角的...,分享给自己的微信好友！
                </marquee>
              </div>
            </div>
            <div class="share-tip">
              <div>备注信息：{{ this.info.remark||'暂无' }}</div>
            </div>


            <div class="good_list">



              <div class="good_list_row" v-for="item in this.list" :key="item.id">
                <div class="image-cell" @click="navGoodDetail(item.good_id)"><img :src="item.good_img"></div>
                <div class="info-cell" @click="navGoodDetail(item.good_id)">
                  <div class="text-container"> {{ item.good_name }}</div>
                  <div class="price" style="color:#f85205;">{{ item.good_integral }}</div>
                  <div class="quantity" style="text-align: right;">x{{ item.number }}</div>
                </div>
              </div>



            </div>



            <div class="cart_content_bottom">
              <div class="flex-spacer"></div>
              <div class="cart_content_bottom_r">
                <div>总计：<span class="total-count">{{ this.info.total_number }}件</span>
                </div>
                <div class="generate-link" style="width:80px;" @click="goHuace()">查看画册</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import wx from "weixin-js-sdk";
  import {
    Toast
  } from "vant";
  import {
    getCurrentRouteUrl
  } from '../utils/share-url';
  export default {
    data() {
      return {
        //v-if为true显示，false消失
        btnFlag: false,
        huace_status: "1",
        hauce_errmsg: "",
        is_loading: true,
        list: [],
        info: [],
        huace_id: ''
      };
    },

    // vue的两个生命钩子，这里不多解释。
    //mounted是vue已经加载好了；destroyed是vue已经销毁了
    // window对象，所有浏览器都支持window对象。它表示浏览器窗口，监听滚动事件
    mounted: function() {

    },
    destroyed: function() {

    },

    methods: {
      // 跳转详情页
      navGoodDetail(goods_id) {
        //id是画册的id
        var id = this.huace_id;
        this.$router.push({
          path: "/detail1",
          query: {
            goods_id: goods_id,
          },
        });
      },
      backNav() {
        var id = this.huace_id;

        if (window.history.length <= 1) {
          this.$router.push({
            path: "/",
            query: {
              id: id,
            },
          });
          return false;
        } else {
          this.$router.back();
          return false;
        }
        //上面都没执行就说明卡在当前页不是最后一条， histroy记录数量大于1，又没有回退记录，只能返回首页，
        //如果上面都执行了 页面都跳走了，这个也就不用管了
        setTimeout(() => {
          this.$router.push({
            path: "/",
            query: {
              id: id,
            },
          });
        }, 500);
      },
      goHuace() {
        var id = this.huace_id;
        this.$router.push({
          path: "/",
          query: {
            id: id,
          },
        });
        return false;
      },
      initShow: function() {
        const app = this;
        let keynum = this.$route.query.keynum;

        var token = localStorage.getItem("token");
        this.$http
          .get(
            api_url +
            `action=get_order_info&token=${token}&keynum=${keynum}`
          )
          .then((res) => {

            //如果失败了
            if (res.data.sta != 200) {
              this.huace_status = 0;
              this.hauce_errmsg = res.data.msg;
              return;
            }

            //设置变量
            //document.title = res.data.share_title;
            document.title = "产品采购清单";
            app.list = res.data.list;
            app.info = res.data.info;

            app.is_loading = false;
            //微信分享
            app.wechatShare(app.info.huace_id);
            app.huace_id = app.info.huace_id;


          })
          .catch(function(error) {
            console.log(error);
          });
      },
      // 跳转方案详情
      goFanganDetail() {
        //id是画册的id
        var id = this.$route.query.id;
        this.$router.push({
          path: "/fangandetail",
          query: {
            id: id
          },
        });
      },
      //微信分享
      wechatShare(huace_id) {
        var app = this;
        var id = huace_id;
        var token = localStorage.getItem("token");
        var shareLink = getCurrentRouteUrl(this.$route);
        //必须要url编码，如果不变吗，url的参数值里面有&拼接会被当做接口参数以及参数值，再次发送
        let url = encodeURIComponent(window.location.href);
        var pathUrl =
          api_url + `action=get_wxshare_param&id=${id}&token=${token}&url=${url}`;
        this.$http
          .request({
              url: pathUrl,
            },
            "GET"
          )
          .then((res) => {
            console.log("get_wxshare_param", res);
            if (res.data.sta == 200) {
              let data = res.data;
              //通过config接口注入权限验证配置
              wx.config({
                debug: data.res.is_debug_fx,
                appId: data.res.appId,
                timestamp: data.res.timestamp,
                nonceStr: data.res.nonceStr,
                signature: data.res.signature,
                jsApiList: [
                  "updateTimelineShareData",
                  "updateAppMessageShareData",
                  "showAllNonBaseMenuItem",
                  "hideAllNonBaseMenuItem",
                  "showMenuItems",
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline",
                ],
              });
              //预处理下分享数据
              let share_title = "产品采购清单";
              let share_desc = "这里面是我要采购的礼品和其他要求";
              let share_img = window.location.origin + "/static/pic/gift1.png"; // 改为绝对路径
              console.log("share_img", share_img);

              //通过ready接口处理成功验证
              wx.ready(function() {
                //展示所有基础类型按钮，20211012日，微信增加了直接访问网址，出现一个拦截，这种情况下不显示分享按钮，先收藏然后在分享就可以，bug
                wx.showAllNonBaseMenuItem();
                //旧的版本还有分享成功回调。不过不知道能用多久还
                wx.onMenuShareAppMessage({
                  title: share_title, // 分享标题
                  desc: share_desc, // 分享描述
                  link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: share_img, // 分享图标
                  type: "", // 分享类型,music、video或link，不填默认为link
                  dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了1")
                    var link = escape(shareLink);
                    var desc = share_desc;
                    var title = share_title;
                    var imgUrl = share_img;
                    var share_type = "1";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
                wx.onMenuShareTimeline({
                  title: share_title, // 分享标题
                  link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                  imgUrl: share_img, // 分享图标
                  success: function() {
                    // 用户点击了分享后执行的回调函数
                    //alert("分享执行成功了2")
                    var link = escape(shareLink);
                    var desc = "";
                    var title = share_title;
                    var imgUrl = share_img;
                    var share_type = "2";
                    var pathUrl =
                      api_url +
                      `action=notify_share_success&id=${id}&token=${token}&link=${link}&desc=${desc}&title=${title}&imgUrl=${imgUrl}&share_type=${share_type}`;
                    app.$http
                      .request({
                          url: pathUrl,
                        },
                        "GET"
                      )
                      .then((res) => {
                        console.log("notify_share_success", res);
                      });
                  },
                });
              });
            }
          });
      },
    },

    created: function() {
      //初始化
      this.initShow();
    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .back-link {
    display: inline-block;
    color: black;
    text-decoration: none;
    border-radius: 5px;
    font-size: 16px;
  }

  .back-link span {
    font-size: 18px;
  }

  .back-link font {
    font-size: 13px;
  }


  .text-container {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    /* 限制在一个块元素显示的文本的行数 */
    -webkit-box-orient: vertical;
    /* 将块元素作为弹性伸缩盒子模型显示 */
    overflow: hidden;
    /* 隐藏超出的内容 */
    text-overflow: ellipsis;
    /* 用省略号(...)代替超出的文本 */
    font-size: 14px;
    font-weight: bold;
  }

  .page-body {
    max-width: 1000px;
    min-height: 100vh;
    margin: 0 auto;
    background-color: #eee;
    /*padding-top: 40px;*/
    padding-bottom: 64px;
  }

  .cart_content {}

  .cart_content_div {
    display: flex;
    flex-direction: column;
  }

  .cart_content_top {
    background-color: #333;
    /* 深色背景 */
    color: white;
    /* 文字颜色为白色 */
    padding: 20px;
    overflow-y: auto;
    /* 允许垂直滚动 */
    max-height: 300px;
    /* 设置最大高度以限制内容高度 */
  }

  .cart_content_top_center {
    text-align: center;
    /* 居中文本 */
  }


  .cart_content_top_l {
    width: 33%;
    margin-left: 10px;
    cursor: pointer;
  }

  .cart_content_top_center {
    flex: 1;
    text-align: center;
  }

  .cart_content_top_r {
    width: 33%;
    text-align: center;
    margin-right: 10px;
  }

  .spacer {
    height: 40px;
  }

  .share-tip {
    background-color: rgb(251, 251, 251);
    border: 1px solid #eee;
    border-radius: 10px;
    margin: 5px;
    height: 50px;
    line-height: 50px;
    text-align: left;
  }

  .share-tip div {
    color: red;
    text-indent: 20px;
  }

  .good_list {
    background-color: rgb(251, 251, 251);
    border: 1px solid #eee;
    border-radius: 10px;
    margin: 5px;
    overflow-y: auto;
  }

  .good_list_row {
    display: flex;
    flex-direction: row;
    height: 119px;
    align-items: center;
    justify-content: center;
    margin: 10px 20px;
  }

  .image-cell {
    width: 100px;
  }

  .image-cell img {
    width: 80px;
    height: 80px;
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .info-cell {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .text-container {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .price {
    color: #f85205;
  }

  .quantity {
    text-align: right;
  }

  .cart_content_bottom {
    border: 1px solid #eee;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    background-color: rgb(251, 251, 251);
  }

  .flex-spacer {
    flex: 1;
  }

  .cart_content_bottom_r {
    width: 60%;
    text-align: right;
    margin-right: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .total-count {
    color: #e8c5af;
  }

  .generate-link {
    background-color: #ff5c01;
    color: #fff;
    border-radius: 10px;
    height: 30px;
    line-height: 30px;
    padding: 3px 10px;
    cursor: pointer;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/fangandetail.vue